<template>
  <div class="relative w-full min-h-full lg:min-h-0">
    <candidate-slot-grid
      :candidate-ids="slots"
      :candidate-drag-bus="candidateDragBus"
      :drag-mode="dragMode"
      :drop-mode="'insert'"
      :show-add-candidate-button="showAddCandidateButton"
      :allow-drop-on-empty-slot="false"
      @candidatedrop="onCandidateDrop"
      @mountedCandidateSlotGrid="onMountedCandidateSlotGrid"
    ></candidate-slot-grid>
    <div
      v-if="!loaded"
      class="absolute top-0 left-0 w-full h-full"
      style="background-color:rgba(255,255,255,0.8)"
    ></div>
  </div>
</template>

<script>
import CandidateSlotGrid from "../people/CandidateSlotGrid";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "FavoritesEditor",
  components: { CandidateSlotGrid },
  props: {
    /**
     * @var The candidate ids in their correct order
     */
    candidateIds: {
      type: Array,
      required: true
    },
    /**
     * @var Drag bus for inter component communication of drag and drop actions
     */
    candidateDragBus: {
      type: Vue,
      required: true
    },
    filtersActive: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      dragMode: null,
      /**
       * @var The candidate ids in their correct order, with null for empty slots
       */
      slots: null,
      showAddCandidateButton: false,
      loaded: false
    };
  },
  mounted() {
    this.updateSlots();
    this.updateDragMode();
  },
  computed: {
    ...mapGetters("election", ["activeElection"]),
    ...mapGetters("candidate", ["candidates", "matches"])
  },
  watch: {
    filtersActive() {
      this.updateDragMode();
    },
    candidateIds() {
      this.updateSlots();
    }
  },
  methods: {
    ...mapActions("candidate", ["rankCandidate"]),
    onMountedCandidateSlotGrid() {
      this.$emit("mountedCandidateSlotGrid");
      this.loaded = true;
    },
    updateDragMode() {
      this.dragMode = this.filtersActive ? null : "drag";
    },
    updateSlots() {
      const candidateIds = this.candidateIds;
      const totalCandidates = this.candidates.length;
      const hasMatchedAllCandidates = candidateIds.length === totalCandidates;
      const matchesArray = [
        ...Object.values(this.matches).map(m => m.rank || 0)
      ];
      const maxRank = Math.max(...matchesArray);
      const desiredEntriesCount = !this.filtersActive
        ? Math.max(this.activeElection.seats, candidateIds.length, maxRank)
        : candidateIds.length;
      const slots = [];
      slots.length = desiredEntriesCount;
      for (let i = 0; i < desiredEntriesCount; i++) {
        slots[i] = i < candidateIds.length ? candidateIds[i] : null;
      }
      this.loaded = false;
      this.slots = slots;
      this.showAddCandidateButton = !hasMatchedAllCandidates;
    },
    onCandidateDrop(event) {
      this.rankCandidate({
        candidateId: event.candidateId,
        rank: event.index + 1
      });
    }
  }
};
</script>

<style scoped></style>
